import React, { ChangeEvent } from "react";
import { InputAdornment } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import * as S from "./styles";

interface ILogin {
  setUserName: (e: string) => void;
  setPassword: (e: string) => void;
  handleLogin: () => void;
}

const Login: React.FC<ILogin> = ({ setUserName, setPassword, handleLogin }) => {
  return (
    <S.Container>
      <S.Label>Usuário</S.Label>
      <S.InputBox>
        <S.Input
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setUserName(e.target.value)
          }
          placeholder="Digite seu usuário"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PersonOutlineIcon style={{ color: "#999999" }} />
              </InputAdornment>
            ),
          }}
        />
      </S.InputBox>

      <S.Label>Senha</S.Label>
      <S.InputBox>
        <S.Input
          type="password"
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setPassword(e.target.value)
          }
          placeholder="Digite sua senha"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockOutlinedIcon style={{ color: "#999999" }} />
              </InputAdornment>
            ),
          }}
        />
      </S.InputBox>

      <S.Buttons>
        <S.ForgetPassword
          as="a"
          href="https://wa.me/5519999551801"
          target="_blank"
          rel="noopener noreferrer"
        >
          Entre em contato
        </S.ForgetPassword>
        <S.Login onClick={() => handleLogin()} variant="contained">
          Entrar
        </S.Login>
      </S.Buttons>
    </S.Container>
  );
};

export default Login;
